export default __webpack_public_path__ + "static/media/kyc-bitmarketperu.66e6c7f1.webp";